export default __webpack_public_path__ + "static/media/fa-thin-100.86104948.woff2";